<template>
  <div class="table-content" :key="key" v-for="(item, key) in tableData.tbody">
    <template
      v-for="(columnItem, index) in Object.keys(tableData.columns)"
      :key="index"
    >
      <h5 v-if="columnItem == 'prop0'">
        <span :style="columnItem == 'prop0' ? 'display:block' : ''"
          >{{ tableData.columns[columnItem] }}：{{ item[columnItem] }}</span
        >
      </h5>
      <span class="table-text" v-else
        >{{ tableData.columns[columnItem] }}：{{ item[columnItem] }}</span
      ></template
    >
  </div>
</template>

<script>
export default {
  name: "CardFieldTable",
  data() {
    return {
      tableData: {}
    };
  },
  props: {
    fieldData: {
      type: Object,
      defalut: () => {
        return {};
      }
    }
  },
  created() {
    this.tableData = JSON.parse(this.fieldData.fieldValue);
  },
  components: {},
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="less">
.table-content {
  padding-top: 10px;
  border-bottom: 1px solid #dcdcdc;
  overflow: hidden;
}
.table-content h5 {
  display: inline;
  line-height: 26px !important;
}
.table-text {
  padding-right: 40px;
  font-size: 14px;
  color: #969799;
  line-height: 30px !important;
}
</style>
